import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import Bull from "../../components/bullet/Bull";

const bull = <Bull scale="scale(1.8) " color="#18ffff" />;
export default function ModalPopupMap(props: any) {
  return (
    <Grid
      container
      spacing={2}
      className="mTop5 "
      sx={{
        minWidth: 320,
        textAlign: "start",

        color: "#fff",
      }}
    >
      <Grid container xs={12} className="cardMapContainerFirst ">
        <Grid xs={2}>
          <StoreMallDirectoryIcon
            style={{
              background: "#fff",
              border: "none",
              color: "#34495E",
              marginBottom: "12px",
            }}
            className="iconProfile  marginLeft-15"
          />
        </Grid>
        <Grid
          xs={10}
          className=" textFont14"
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          {props.supplierTitle}{" "}
          <span className=" popupModalColor">
            &nbsp; (شعبه {props.cityTitle}){" "}
          </span>
        </Grid>
      </Grid>
      <Grid className="navi-separator "></Grid>
      {props.salesInfos.map((item: any) => (
        <Grid
          xs={12}
          container
          spacing={2}
          className=" textFont11 cardMapContainer"
          style={{ padding: "2.2vh 1vh 1.2vh 1vh" }}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={6} style={{ paddingTop: "0px" }}>
            {bull}
            {item.title}
          </Grid>
          <Grid item xs={2} style={{ paddingTop: "10px" }}>
            تعداد:&nbsp;
            <span className=" popupModalColor">{item.count}</span>
          </Grid>
          <Grid item xs={4} style={{ paddingTop: "10px" }}>
            جمع مبلغ:&nbsp;
            <span className=" popupModalColor">
              {item.totalAmount.toLocaleString("fa")}
            </span>{" "}
            ریال
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
